import {SecurityFileDiff} from "./security-file-diff";
import {Utils} from "../../../shared/utils/utils";

export class SecurityFileDiffMapper {

  public static map(data: any, securityIssueStatus: string): SecurityFileDiff {
    const securityFileDiff: SecurityFileDiff = new SecurityFileDiff();

    securityFileDiff.fileSize = data.file_size ? data.file_size : null;
    securityFileDiff.date = data.file_time ? Utils.getDate(data.file_time * 1000) : null;
    switch (securityIssueStatus.toLowerCase()) {
      case 'added':
        securityFileDiff.diff = data.data ? SecurityFileDiffMapper.getAddedFileDiff(data) : null;
        break;

      case 'missing':
        securityFileDiff.diff = data.data ? SecurityFileDiffMapper.getRemovedFileDiff(data) : null;
        break;

      default:
        securityFileDiff.diff = data.diff ? SecurityFileDiffMapper.getModifiedFileDiff(data) : null;
        break;
    }

    return securityFileDiff;
  }

  public static getModifiedFileDiff(data: any): any[] {
    const diffRows: any[] = [];
    let lineNumber: number = 0;
    let originalLineNumber: number = 0;
    let added: boolean = false;
    let removed: boolean = false;
    const status = {
      UNMODIFIED: 0,
      DELETED: 1,
      INSERTED: 2
    };
    data.diff.forEach((line: Object) => {
      const content: Object = line;

      if (content[1] === status.INSERTED) {
        added = true;
      }
      else if (content[1] === status.DELETED) {
        removed = true;
      }

      if (added) {
        ++lineNumber;
      }
      else if (removed) {
        ++originalLineNumber;
      }
      else {
        ++lineNumber;
        ++originalLineNumber;
      }

      diffRows.push({
        lineNumber: removed ? '' : lineNumber.toString(),
        originalLineNumber: added ? '' : originalLineNumber,
        added: added,
        removed: removed,
        content: content[0]
      });
      added = false;
      removed = false;
    });

    return diffRows;
  }

  public static getAddedFileDiff(data: any): any[] {
    const diffRows: any[] = data.file.map((line: string, index: number) => {
      return {
        lineNumber: index + 1,
        originalLineNumber: '',
        added: true,
        removed: false,
        content: line
      };
    });

    return diffRows;
  }

  public static getRemovedFileDiff(data: any): any[] {
    const diffRows: any[] = data.original_file.map((line: string, index: number) => {
      return {
        lineNumber: '',
        originalLineNumber: index + 1,
        added: false,
        removed: true,
        content: line
      };
    });

    return diffRows;
  }

}
